$('.moreless-button').click(function() {
    $('.moretext').slideToggle();
    if ($('.moreless-button').text() == "Read more +") {
        $(this).addClass('noTransform')
        $(this).text("Collapse -")
    } else {
        $(this).removeClass('noTransform')
        $(this).text("Read more +")
    }
});
// $(".variated_atc_form select").change(function(e){
//     const select = $(this);
//     const selected = select.find(":selected").text();
//     const parent = select.closest(".product-grid-item");
//     parent.find("[data-variant]").addClass("hidden");
//     parent.find("[data-variant='" + selected.trim() + "']").removeClass("hidden");
//     parent.find("[data-variant-title]").css("display","none");
//     parent.find("[data-variant-title='" + selected.trim() + "']").css("display","block");
// });